"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFeatureFlags = exports.parseConfig = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

var _excluded = ["type"];

var _CAST_FUNCTIONS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var withDefault = function withDefault(castFunction) {
  return function (value, options) {
    if (!value) {
      return castFunction(options["default"], options);
    }

    return castFunction(value, options);
  };
};

var CAST_FUNCTIONS = (_CAST_FUNCTIONS = {}, (0, _defineProperty2["default"])(_CAST_FUNCTIONS, _constants.TYPES.BOOLEAN, withDefault(function (value) {
  return value.toUpperCase() === 'TRUE';
})), (0, _defineProperty2["default"])(_CAST_FUNCTIONS, _constants.TYPES.ARRAY, withDefault(function (value, options) {
  return value.split(options.separator);
})), _CAST_FUNCTIONS);

var parseFeatureFlags = function parseFeatureFlags(featureFlags) {
  return _constants.FLAGS.reduce(function (result, flag) {
    var _FLAGS_CONFIG$flag = _constants.FLAGS_CONFIG[flag],
        type = _FLAGS_CONFIG$flag.type,
        options = (0, _objectWithoutProperties2["default"])(_FLAGS_CONFIG$flag, _excluded);
    var flagValue = featureFlags.configuration[flag];
    return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, flag, CAST_FUNCTIONS[type](flagValue, options)));
  }, {});
};

exports.parseFeatureFlags = parseFeatureFlags;

var parseConfig = function parseConfig(config) {
  return config.hotel.reduce(function (result, configSection) {
    return _objectSpread(_objectSpread({}, result), configSection);
  }, {});
};

exports.parseConfig = parseConfig;